import { signal } from '@preact/signals';

const ROUTES = ['dashboard', 'orders', 'search', 'cart', 'promotions', 'useful', 'about'];
export const DEFAULT_ROUTE = 'dashboard';

export const currentRoute = signal(parseRoute(window.location.pathname));

function parseRoute(pathname) {
  const route = pathname.replace(/^\//, '').split('/')[0] || DEFAULT_ROUTE;
  return ROUTES.includes(route) ? route : DEFAULT_ROUTE;
}

export function navigate(route) {
  if (!ROUTES.includes(route)) route = DEFAULT_ROUTE;
  if (route === currentRoute.value) return;
  const url = route === DEFAULT_ROUTE ? '/' : `/${route}`;
  window.history.pushState({ route }, '', url);
  currentRoute.value = route;
}

export function initRouter() {
  // Поддержка кнопок Назад/Вперёд браузера.
  window.addEventListener('popstate', () => {
    currentRoute.value = parseRoute(window.location.pathname);
  });
}

export function getBreadcrumb(route) {
  return (
    {
      dashboard: 'Главная B2B',
      orders: 'Заказы',
      search: 'Поиск товаров',
      cart: 'Корзина',
      promotions: 'Акции',
      useful: 'Полезное',
      about: 'Кондор-Юг',
    }[route] || ''
  );
}
